<template>
  <div>
    <vs-row>
      <vs-col>
        <vs-card class="cardx">
          <div slot="header" style="padding: 10px">
            <h3>Checking Issues</h3>
          </div>
          <div>
            <vs-row>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <div
                  class="mb-3"
                  style="display: inline-block; vertical-align: middle"
                >
                  <vs-dropdown
                    class="mr-2 mt-2"
                    vs-custom-content
                    vs-trigger-click
                    vs-drop-right
                    :vs-dropdown-visible="true"
                  >
                    <vs-chip
                      transparent
                      color="primary"
                      style="min-width: 130px"
                    >
                      <b>From</b>: {{ since }}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker
                        @input="updateDateQuery"
                        calendar-class="border-none"
                        :inline="true"
                        v-model="dates.since"
                        format="yyyy-MM-dd"
                      ></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>

                  <vs-dropdown
                    class="mr-2"
                    vs-custom-content
                    vs-trigger-click
                    vs-drop-right
                    :vs-dropdown-visible="true"
                  >
                    <vs-chip
                      transparent
                      color="primary"
                      style="min-width: 130px"
                    >
                      <b>To</b>: {{ until }}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker
                        @input="updateDateQuery"
                        calendar-class="border-none"
                        :inline="true"
                        v-model="dates.until"
                        format="yyyy-MM-dd"
                      ></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </vs-col>
              <vs-col
                vs-lg="4"
                vs-sm="4"
                vs-xs="4"
                style="vertical-align: middle"
              >
                <div style="text-align: right; vertical-align: middle">
                  <vs-button
                    class="mr-3 mb-3"
                    @click="download"
                    color="primary"
                    type="filled"
                    >Download</vs-button
                  >
                </div>
              </vs-col>
            </vs-row>

            <div v-if="report">
              <vs-table stripe :data="report.checkins">
                <template slot="thead">
                  <vs-th style="min-width: 120px"> Viaje </vs-th>
                  <vs-th> Horario </vs-th>
                  <vs-th> Conductor </vs-th>
                  <vs-th> Codigo </vs-th>
                  <vs-th> Lectura escaner </vs-th>
                  <vs-th> Causa </vs-th>
                  <vs-th> Link detalle del viaje </vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="'row' + index" v-for="(item, index) in data">
                    <vs-td>
                      {{ item.route_name }}
                    </vs-td>
                    <vs-td>
                      {{ item.trip_hour }}
                    </vs-td>
                    <vs-td>
                      {{ item.driver_name }}
                    </vs-td>
                    <vs-td>
                      {{ item.code }}
                    </vs-td>
                    <vs-td>
                      {{ item.scanned_code }}
                    </vs-td>
                    <vs-td>
                      {{ item.reason }}
                    </vs-td>
                    <vs-td>
                      <router-link :to="showTrip(item.trip_id)">
                        Detalles</router-link
                      >
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

              <div class="mt-3 mb-3">
                <span style="float: left">
                  <vs-select
                    @input="filters.page = 1"
                    class=""
                    label=""
                    v-model="filters.limit"
                    width="100px"
                    size="small"
                  >
                    <vs-select-item
                      :key="'lim-' + index"
                      :value="item.value"
                      :text="item.text"
                      v-for="(item, index) in limitOptions"
                    />
                  </vs-select>
                </span>
                <pagination
                  :last-page="report.pagination.pages"
                  v-model="filters.page"
                />
              </div>
            </div>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { CalendarIcon } from "vue-feather-icons";
const FileDownload = require("js-file-download");
import limitOptions from "../../../constants/limit";

export default {
  name: "Passenger",
  components: {
    Datepicker,
    CalendarIcon,
  },
  data() {
    return {
      filters: {},
      dates: {
        page: 0,
        since: moment().subtract(1, "weeks").toDate(),
        until: moment().toDate(),
      },
      report: null,
      page: 0,
      limitOptions,
    };
  },
  computed: {
    since() {
      return moment(this.dates.since).format("YYYY-MM-DD");
    },
    until() {
      return moment(this.dates.until).format("YYYY-MM-DD");
    },
    ...mapState("zones", ["zones"]),
  },
  watch: {
    filters: {
      deep: true,
      handler(newVal, oldVal) {
        this.setRouteQuery();
        //if(!_.isEqual(newVal, oldVal))
        this.doSearch();
      },
    },
  },
  created() {
    if (this.$route.query.since) {
      this.dates.since = moment(this.$route.query.since).toDate();
    }
    if (this.$route.query.until) {
      this.dates.until = moment(this.$route.query.until).toDate();
    }
    this.filters = {
      limit: "20",
      ...this.$route.query,
      page: this.$route.query.page ? Number(this.$route.query.page) : 1,
      since: this.since,
      until: this.until,
    };
    this.doSearch = _.debounce(this.getItems, 300);
  },
  methods: {
    ...mapActions("partners", ["getCodesReport", "downloadCodesReport"]),
    setRouteQuery() {
      let query = { ...this.filters, page: `${this.filters.page}` };
      if (!_.isEqual(query, this.$route.query)) {
        try {
          this.$router.push({ query: query });
        } catch (error) {}
      }
    },
    updateDateQuery() {
      this.page = 1;
      this.filters = {
        ...this.filters,
        page: "1",
        since: this.since,
        until: this.until,
      };
    },
    showTrip(row) {
      return { name: "partner.trips.details", params: { trip_id: row } };
    },
    getItems() {
      this.$vs.loading({ type: "point" });
      this.getCodesReport(_.cloneDeep(this.filters))
        .then((data) => {
          this.report = data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    download() {
      this.$vs.loading({ type: "point" });
      this.downloadCodesReport({
        since: this.since,
        until: this.until,
        export: true,
        format: "csv",
      })
        .then((response) => {
          FileDownload(response.data, `codes-${this.since}-${this.until}.csv`);
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style scoped></style>
